export const stage_tracks = [
	"Map_S1",
	"Map_S1fin",
	"Map_S2",
	"Map_S2fin",
	"Map_S3",
	"Map_S3",
];

const idle_tracks = [
	"C01",
	"C01Sword_battle",
	"C01SwordIK_battle",
	"C02",
	"C02Staff_stay",
	"C02Ball_fin",
	"C03_stay",
	"C03ACtrl_stay",
	"C03A_stay",
	"C03bow_stay",
	"Newhoop_stay",
	"Box_stay",
];

const battle_tracks = [
	"C01",
	"C01Sword_battle",
	"C01SwordIK_battle",
	"C02",
	"C02Staff_battle",
	"C02BallCtrl_battle",
	"C02Ball_battle",
	"C03_battle",
	"C03bowCtrl_battle",
	"C03A_battle",
	"C03bow_battle",
	"C03ACtrl_battle",
	"Newhoop_stay",
	"Box_stay",
];

const fin_tracks = [
	"C01_fin",
	"C01Sword_fin",
	"C02_fin",
	"C02Staff_fin",
	"C02Ball_fin",
	"C03_fin",
	"C03bowCtrl_fin",
	"Newhoop_fin",
	"Box_fin",
	"Boxtop_fin",
];

export const stance_tracks = [idle_tracks, battle_tracks, fin_tracks];

export function get_random_battle() {
	const choices = [0, 2, 4];
	return choices[Math.floor(Math.random() * choices.length)];
}

export function get_random_fin() {
	const choices = [1, 3, 5];
	return choices[Math.floor(Math.random() * choices.length)];
}

export function get_stage_track(stage_idx) {
	return stage_tracks[stage_idx];
}

export function get_stance_tracks(stance_idx) {
	return stance_tracks[stance_idx];
}

export function get_anims(animations, track_names) {
	return animations.filter((c) => {
		return track_names.includes(c.name);
	});
}
